<div class="input-group" [ngClass]="size ? 'input-group-' + size : null">
  <input
    data-dd-action-name="date-input.date-input"
    #input
    appFormControl
    ngbDatepicker
    #datePicker="ngbDatepicker"
    [(ngModel)]="modelStruct"
    [minDate]="minDateStruct!"
    [maxDate]="maxDateStruct!"
    [footerTemplate]="footerTemplate!"
    [dayTemplate]="periodDayTemplate"
    [disabled]="disabled"
    container="body"
    (ngModelChange)="onChange($event)"
    (blur)="onTouched()"
    (dateSelect)="onTouched()"
    [placeholder]="placeholder"
  />
  <button
    data-dd-action-name="date-input.calendar-button"
    type="button"
    class="btn btn-outline rounded-end"
    [disabled]="disabled"
    (click)="datePicker.toggle()"
  >
    <i-lucide name="calendar"></i-lucide>
  </button>
  <ng-content></ng-content>
</div>

<ng-template
  #periodDayTemplate
  let-date
  let-currentMonth="currentMonth"
  let-selected="selected"
  let-disabled="disabled"
  let-focused="focused"
>
  <div
    class="aa-day-cell"
    [class.outside]="date.month !== currentMonth"
    [class.focused]="focused"
    [class.bg-primary]="selected"
    [class.text-white]="selected"
    [class.text-muted]="disabled || date.month !== currentMonth"
    [class.aa-period-even]="!selected && getPeriodParity(date) === 'even'"
    [class.aa-period-odd]="!selected && getPeriodParity(date) === 'odd'"
    [class.aa-today]="isToday(date)"
    [class.btn-light]="!selected && getPeriodParity(date) === null"
  >
    {{ date.day }}
  </div>
</ng-template>
